export default "__VITE_ASSET__BfIon8TZ__"